import { WeatherItemConfig } from './weather.types';

export const DEFAULT_WEATHER_ITEM_CONFIG: WeatherItemConfig = {
  statusSection: true,
  removeIcon: false,
};
